import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { styled } from '@mui/material/styles';

import { GAP_SIZE, TextVariant } from './constants';

export const StyledErrorIcon = styled(VisibilityOffOutlinedIcon, {
  shouldForwardProp: prop => prop !== 'paddingVariant' && prop !== 'isPointer',
})<{
  paddingVariant: TextVariant;
  width: number;
  height: number;
  isPointer?: boolean;
}>`
  box-sizing: content-box;
  cursor: ${({ isPointer }) => isPointer && 'pointer'};
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;
  padding-right: ${({ paddingVariant }) => `${paddingVariant === TextVariant.Horizontal ? GAP_SIZE : 0}px`};
  padding-bottom: ${({ paddingVariant }) => `${paddingVariant === TextVariant.Vertical ? GAP_SIZE : 0}px`};
  color: ${({ theme }) => theme.palette.text.disabled};
`;
